// import React is not needed for JSX in React 17+

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import StudentSay from "./StudentSay";
import '../pilotSections.css';
import Categories from "./Categories";
import TopCategories from "./TopCategories";
import AnnouncementPopup from "./AnnouncementPopup";



const images = [
  `${process.env.PUBLIC_URL}/assets/img/side1.webp`,
  `${process.env.PUBLIC_URL}/assets/img/hero.webp`,
  `${process.env.PUBLIC_URL}/assets/img/right2.png`,
];



function Hero() {
	const [index, setIndex] = useState(0);
	useEffect(() => {
		const timer = setInterval(() => {
			setIndex((i) => (i + 1) % images.length);
		}, 4000); // 4 seconds

		return () => clearInterval(timer);
	}, []);
	return (
		<>
		  <AnnouncementPopup />
			{/* ============================ Hero Banner  Start================================== */}

<div className="image-cover hero-banner">
</div>
			<Categories />
			

			<section className="bg-second" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/section_bg04.jpg)`}}  >
				<div className="container">

					<div className="row justify-content-center">
						<div className="col-xl-6 col-lg-7 col-md-10 text-center">
							<div className="sec-heading center light">
								<h2>How it works</h2>
							</div>
						</div>
					</div>

					<div className="row align-items-center gx-4 gy-4">

						{/* STEP 1 */}
						<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
							<div className="jobstock-posted-box-y78 colored">
								<div className="jobstock-posted-body-y78 text-center">
									<div className="serv-ctr-title mb-3">
										<i className="fa-solid fa-user-plus text-green fs-1"></i>
									</div>
									<div className="serv-ctr-subtitle">
										<h5 className="text-light">Register & Login</h5>
									</div>
									<div className="serv-ctr-decs">
										<p className="text-light opacity-75">
											Create your account and access your personalized dashboard
										</p>
									</div>
								</div>
							</div>
						</div>

						{/* STEP 2 */}
						<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
							<div className="jobstock-posted-box-y78 colored">
								<div className="jobstock-posted-body-y78 text-center">
									<div className="serv-ctr-title mb-3">
										<i className="fa-solid fa-list-check text-green fs-1"></i>
									</div>
									<div className="serv-ctr-subtitle">
										<h5 className="text-light">Choose Your Test</h5>
									</div>
									<div className="serv-ctr-decs">
										<p className="text-light opacity-75">
											Select from various aviation exam categories and start practicing.
										</p>
									</div>
								</div>
							</div>
						</div>

						{/* STEP 3 */}
						<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
							<div className="jobstock-posted-box-y78 colored">
								<div className="jobstock-posted-body-y78 text-center">
									<div className="serv-ctr-title mb-3">
										<i className="fa-solid fa-chart-line text-green fs-1"></i>
									</div>
									<div className="serv-ctr-subtitle">
										<h5 className="text-light">Track Progress</h5>
									</div>
									<div className="serv-ctr-decs">
										<p className="text-light opacity-75">
											Monitor your performance and improve with detailed analytics.
										</p>
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>
			</section>

			 <section className="feature-section">
  <div className="container">

    <div className="text-center mb-5">
      <h2 className="section-heading">Our Mission in Pilot Training</h2>
      <p className="section-subheading">
        Airline-ready training | Ethical guidance | Professional competence
      </p>
    </div>

    <div className="row g-4 justify-content-center">

      <div className="col-lg-4 col-md-6">
        <div className="feature-card-pro">
          <div className="feature-icon-pro">
            <i className="fas fa-book-open"></i>
          </div>
          <h5 className="feature-title-pro">Airline-ready training</h5>
          <p className="feature-text-pro">
            Study material and mock tests prepared by instructors with real-world flying and training experience.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="feature-card-pro">
          <div className="feature-icon-pro">
            <i className="fas fa-bullseye"></i>
          </div>
          <h5 className="feature-title-pro">Ethical guidance</h5>
          <p className="feature-text-pro">
            Topic-wise tests, chapter-wise practice and full-length exams aligned with the latest DGCA pattern.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="feature-card-pro">
          <div className="feature-icon-pro">
            <i className="fas fa-trophy"></i>
          </div>
          <h5 className="feature-title-pro">Professional competence</h5>
          <p className="feature-text-pro">
            Consistently high pass percentage and a growing alumni network flying with leading airlines.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>




			<section style={{ backgroundColor: "#f9fafb", padding: "3rem 0" }}>
				<div className="container">
					<div className="text-center mb-4">
						<h2 style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
							Why Choose Pilot Guide Mock Test?
						</h2>
						<p style={{ color: "#6b7280", margin: 0 }}>
							A complete ecosystem for pilot exam preparation – not just another test series.
						</p>
					</div>

					<div className="row g-4">
						<div className="col-6 col-md-4 col-lg-3 mb-4">
							<div
								style={{
									background: "#ffffff",
									borderRadius: "10px",
									padding: "1.5rem",
									textAlign: "center",
									height: "100%",
									boxShadow: "0 10px 20px rgba(15,23,42,0.05)",
								}}
							>
								<i className="fas fa-user-tie" style={{ fontSize: "2rem", marginBottom: "0.75rem", color: "#f97316" }}></i>
								<h6 style={{ fontWeight: "bold" }}>Industry Experts</h6>
								<p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
									Trainers with real cockpit and exam experience.
								</p>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg-3 mb-4">
							<div
								style={{
									background: "#ffffff",
									borderRadius: "10px",
									padding: "1.5rem",
									textAlign: "center",
									height: "100%",
									boxShadow: "0 10px 20px rgba(15,23,42,0.05)",
								}}
							>
								<i className="fas fa-laptop-code" style={{ fontSize: "2rem", marginBottom: "0.75rem", color: "#f97316" }}></i>
								<h6 style={{ fontWeight: "bold" }}>Modern Online Platform</h6>
								<p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
									Fast, secure, and mobile-friendly exam interface.
								</p>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg-3 mb-4">
							<div
								style={{
									background: "#ffffff",
									borderRadius: "10px",
									padding: "1.5rem",
									textAlign: "center",
									height: "100%",
									boxShadow: "0 10px 20px rgba(15,23,42,0.05)",
								}}
							>
								<i className="fas fa-chart-line" style={{ fontSize: "2rem", marginBottom: "0.75rem", color: "#f97316" }}></i>
								<h6 style={{ fontWeight: "bold" }}>Analytics & Reports</h6>
								<p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
									Track accuracy, speed, and improvement over time.
								</p>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg-3 mb-4">
							<div
								style={{
									background: "#ffffff",
									borderRadius: "10px",
									padding: "1.5rem",
									textAlign: "center",
									height: "100%",
									boxShadow: "0 10px 20px rgba(15,23,42,0.05)",
								}}
							>
								<i className="fas fa-headset" style={{ fontSize: "2rem", marginBottom: "0.75rem", color: "#f97316" }}></i>
								<h6 style={{ fontWeight: "bold" }}>Dedicated Support</h6>
								<p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
									Quick support for login, tests, and results-related queries.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		
		<TopCategories />
 

		 <StudentSay />

		</>
	);
}

export default Hero;
